import { useMutation, useQuery } from '@apollo/client';
import {
  Mutation,
  MutationRegisterAzureTenantArgs,
  Query,
  RegisterAzureTenantInput
} from 'graphql/generated/graphqlTypes';
import { REGISTER_AZURE_TENANT } from 'graphql/mutations';
import { GET_TENANT_REGISTRATION_INFO } from 'graphql/queries';
import { BaseHookProps } from 'hooks/shared/types';
import { useEffect } from 'react';

const useTenantRegistrationInfo = ({ handleFetchError }: BaseHookProps) => {
  const {
    loading: tenantRegistrationInfoLoading,
    data,
    error: tenantRegistrationInfoError
  } = useQuery<Pick<Query, 'getTenantRegistrationInfo'>>(GET_TENANT_REGISTRATION_INFO);

  useEffect(() => {
    if (tenantRegistrationInfoError) handleFetchError('Error while fetching tenant registration info');
  }, [tenantRegistrationInfoError]);

  const [registerAzureTenantMutation, { loading: registerAzureTenantLoading }] = useMutation<
    Pick<Mutation, 'registerAzureTenant'>,
    MutationRegisterAzureTenantArgs
  >(REGISTER_AZURE_TENANT);

  const registerAzureTenant = async (input: RegisterAzureTenantInput) => {
    const result = await registerAzureTenantMutation({
      variables: {
        input
      }
    });
    return result;
  };

  return {
    tenantRegistrationInfo: data?.getTenantRegistrationInfo,
    tenantRegistrationInfoLoading,
    registerAzureTenant,
    registerAzureTenantLoading
  };
};

export default useTenantRegistrationInfo;
